<template>
  <div class="button-service-user-container">
    <div v-if="vUpdate" class="flex-align" style="gap:12px">
      <lp-adm-drop-input :data="users"
                         :selectVal="selectVal"
                         @onSelect="selectUser"
                         added_field="type"
                         placeholder="검색 후 선택"
                         width="300px"
                         listAlign="center"
                         style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
      <button class="button" @click="clickUpdate">변경</button>
      <button class="button" @click="vUpdate=false">취소</button>
    </div>
    <button v-else
      class="button" @click="clickVUpdate">사용자 변경</button>
  </div>
</template>

<script>
import LpAdmDropInput from "../../../../module/common/LpAdmDropInput";
export default {
  name: "ButtonServiceUser",
  components: {LpAdmDropInput},
  props: {
    service: {
      type: Object
    },
    isReceiver: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    user_id() {
      let user = this.isReceiver ? this.service.receiver: this.service.service_user;
      return user ? user.id : 0;
    }
  },
  data() {
    return {
      vUpdate: false,
      users: [],
      value: undefined,
      selectVal: ''
    }
  },
  created() {
    this.getUserList();
  },
  methods: {
    getUserList() {
      this.$axios.get('admin/user/simple').then(res => {
        this.users = res.data;
        this.value = this.users.find(i => i.id === this.user_id);
        this.selectVal = this.value.label;
      });
    },
    selectUser(res) {
      this.value = this.users.find(i => i.id === res.value);
    },
    clickVUpdate() {
      this.value = this.users.find(i => i.id === this.user_id);
      if(this.value) {
        this.selectVal = this.value.label;
      }
      this.vUpdate = true;
    },
    clickUpdate() {
      let key = this.isReceiver ? 'receiver_id' : 'user_id';
      let param = {};
      param[key] = this.value.id;
      this.$axios.patch(this.getUrl(`launchpack/service/${this.service.id}`), param).then(res => {
        if(res.status === 200) {
          let param = this.isReceiver ? this.service.receiver : this.service.service_user;
          if(param === undefined) {
            param = {};
          }
          param.id = this.value.id;
          param.name = this.value.name;
          param.email = this.value.email;
          param.phone = this.value.phone;
          this.vUpdate = false;
        }
      });
    }
  }
}
</script>

<style lang="stylus" scoped>
  .button-service-user-container
    margin 12px 0
  .button
    width 80px
</style>
